import type { Client } from "~/modules/client/api/client/clientTypes.ts";
import type { QuotaWithRelations } from "~/modules/client/api/quota/quotaTypes.ts";
import NewFirstItemCta from "~/modules/client/components/ClientDetailsView/components/NewFirstItemCta";
import QuotaListItem
	from "~/modules/client/components/ClientDetailsView/components/QuotasTabContent/components/QuotaListItem/QuotaListItem.tsx";

type Props = {
	clientData: Client;
	onAddClick: () => void,
	quotas: QuotaWithRelations[]
};

const QuotasTabContent = ({ clientData, onAddClick, quotas }: Props) => {

	if (undefined === quotas || (quotas && 0 === quotas.length))
		return <NewFirstItemCta buttonText="Neues Abrechnungskontingent anlegen"
								headline="Noch keine Abrechnungskontingente vorhanden"
								onCreateClick={onAddClick}
								subLineText={`Füge ein neues Abrechnungskontingent für ${clientData.displayName} hinzu.`} />;

	return <div className="flex flex-col gap-y-4">
		{quotas.map((quota) => <QuotaListItem quota={quota}
											  key={quota.id} />)}
	</div>;

};

export default QuotasTabContent;